// Çoklu-değer metin girişini temiz bir listeye çevirir.
// Ayraçlar: satır sonu, virgül, noktalı virgül veya boşluk. Boşlar atılır, tekrarlar teklenir.
// Örn: "123, 456\n789" -> ["123","456","789"]
export function parseListInput(value) {
    if (!value) return [];
    return [...new Set(
        value
            .split(/[\s,;]+/)
            .map((x) => x.trim())
            .filter(Boolean)
    )];
}
